import { DashboardMonitoringItemT } from 'shared/models/dashboard';

import './PacketsTraffic.scss';

type TrafficT = {
  value?: string;
  nbErrors?: string;
}
type PacketsTrafficItemProps = {
  name?: string;
  uplink?: TrafficT;
  downlink?: TrafficT;
}
function PacketsTrafficItem({ name, uplink, downlink }: PacketsTrafficItemProps) {
  const displayError = (numberErrors?: string) => (
    <p className="packets-traffic__item--error">
      {
        numberErrors !== '0' && numberErrors !== ''
          ? `${numberErrors} error${numberErrors === '1' ? '' : 's'}`
          : ' '
      }
    </p>
  );
  const displayValue = (value: string) => {
    const valueNumber = +value;
    if (valueNumber >= 1000) {
      return `${(valueNumber / 1000).toFixed(1)}K`;
    }
    return valueNumber;
  };
  return (
    <div className="packets-traffic__item">
      { displayError(uplink?.nbErrors) }
      <p className="packets-traffic__item--uplink">{ displayValue(uplink?.value as string) }</p>
      <h4 className="packets-traffic__item--name">{ name }</h4>
      <p className="packets-traffic__item--downlink">{ displayValue(downlink?.value as string) }</p>
      { displayError(downlink?.nbErrors) }
    </div>
  );
}

type PacketsTrafficProps = {
  data?: DashboardMonitoringItemT;
}
function PacketsTraffic({ data }: PacketsTrafficProps) {
  return (
    <>
      <h3 style={{ marginTop: '1.5rem' }}>Packets traffic</h3>
      <div className="packets-traffic">
        <div className="packets-traffic__separator" />
        <div className="packets-traffic--circle">
          <PacketsTrafficItem
            name="Radio Frames"
            uplink={{ value: data?.lpwanPacketsUl, nbErrors: data?.lpwanPacketsUlError }}
            downlink={{ value: data?.lpwanPacketsDl, nbErrors: data?.lpwanPacketsDlError }}
          />
        </div>
        <div className="packets-traffic--empty" />
        <div className="packets-traffic--middle">
          <PacketsTrafficItem
            name="Fragmentation"
            uplink={{ value: data?.schcFragmentUl, nbErrors: data?.schcDefragmentError }}
            downlink={{ value: data?.schcFragmentDl, nbErrors: data?.schcFragmentError }}
          />
          <div className="packets-traffic__line--vertical" />
          <PacketsTrafficItem
            name="Compression"
            uplink={{ value: data?.schcCompressUl, nbErrors: data?.schcDecompressError }}
            downlink={{ value: data?.schcCompressDl, nbErrors: data?.schcCompressError }}
          />
        </div>
        <div className="packets-traffic--empty" />
        <div className="packets-traffic--circle">
          <PacketsTrafficItem
            name="IP Packets"
            uplink={{ value: data?.ipPacketsUl, nbErrors: data?.ipPacketsUlError }}
            downlink={{ value: data?.ipPacketsDl, nbErrors: data?.ipPacketsDlError }}
          />
        </div>
      </div>
    </>
  );
}

export default PacketsTraffic;
